import { render, staticRenderFns } from "./BaseDetail.vue?vue&type=template&id=152624b2&scoped=true"
import script from "./BaseDetail.vue?vue&type=script&lang=js"
export * from "./BaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152624b2",
  null
  
)

export default component.exports